<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info"> Declaration </span>
  </div>

  <div class="container px-[36px]">
    <!-- Declaration -->
    <div #container_wrapper id="container_wrapper" class="container_wrapper">
    
      <div
        class="container-fluid flex justify-center h-auto !pl-0 p-[29px] !pt-0 !m-[3px] !mt-[5px] !mb-[20px] !pb-[0px]"
      >
        <div class="!p-[30px] !pl-0 !pb-0 !bg-[#ffffff] w-full !pt-[0px]">
          <p
            class="!text-[18px] font-medium  !mb-[0px]  !pt-0 !pb-[10px] !text-[#21252A]"
          >
            I confirm that the information provided in this Pre-Qualification
            Questionnaire is accurate and complete. I understand that false
            information could result in disqualification from this procurement
            process.
          </p>
          <p
            class="!text-[18px] font-semibold  !mb-[0px] !pt-[12px] !pb-[22px] !text-[#21252A]"
          >
            Authorized Signatory
          </p>
          <div
            class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 container !mb-[0px]"
          >
            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                  class="!w-[26.302vw] !h-[4.897vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Name </mat-label>
                  <input
                    matInput
                    formControlName="authorized_signatory_name"
                    placeholder="Name"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-[3.125rem] !pt-0 !mb-[40px] !pb-0">
              <div class="rounded p-10  !pb-0 !pt-0">
                <mat-form-field
                class="!w-[26.302vw] !h-[4.897vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Position </mat-label>
                  <input
                    matInput
                    formControlName="authorized_signatory_position"
                    placeholder="Position"
                  />
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-0 !pt-0 !mb-[40px] !pb-0">
              <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
                <mat-form-field
                class="!w-[26.302vw] !h-[4.897vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Datel </mat-label>
                  <input
                    matInput
                    [matDatepicker]="declaration_date"
                    formControlName="authorized_signatory_signature_date"
                    placeholder="Date"
                  />
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="declaration_date"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #declaration_date startView="year"></mat-datepicker>
                </mat-form-field>
              </div>
            </div>

            <div class="container p-5 !pl-[3.125rem] !pt-0 !mb-[40px] !pb-0">
              <div class="rounded p-10  !pb-0 !pt-0">
                <mat-form-field
                class="!w-[26.302vw] !h-[4.897vh] !mb-[0px]"
                  appearance="outline"
                >
                  <mat-label> Signature </mat-label>
                  <input
                    matInput
                    formControlName="authorized_signatory_signature"
                    placeholder="Signature"
                  />
                </mat-form-field>
              </div>
            </div>

          </div>
          <div class="container p-0 !pt-0 !pb-0 !mb-[41px]">
            <div class="rounded p-10 !pl-0 !pb-0 !pt-0">
              <div
                class="!p-10 !pb-0 !pt-0 !pl-0 flex items-center !w-full grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-1"
              >
                <label class="font-semibold "> Disclaimer </label>
                    <p class="!font-normal !text-justify">The submission of this Pre-Qualification Questionnaire (PQQ) does not constitute a binding agreement or obligation for the applicant or the issuing organization. The information provided in this form is for evaluation purposes only and will be treated confidentially. However, the issuing organization reserves the right to verify the details provided and may use this information as part of the selection process.

                      Submission of this PQQ does not guarantee shortlisting, approval, or further communication. The issuing organization reserves the right to accept, reject, or request additional information without assigning any reason.
                      
                      By submitting this form, the applicant acknowledges and agrees to these terms.
                    </p>


                <div class="flex">
                  <div class="!mr-2">
                    <input
                      type="checkbox"
                      formControlName="disclaimer_accepted"
                      (change)="disclaimerAccepted($event)"
                    />
                  </div>
                  <div>
                    <p class="!font-normal !text-justify">
                      I acknowledge and accept the disclaimer above
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
